// extracted by mini-css-extract-plugin
export default {"term-finder__main-content":"W2mupK"};